import { api } from '@services';

import Product, { IProduct, IProductApiModel } from '@models/Product.model';

const getProduct = async (id: string | null): Promise<IProduct> => {
  const { data: product } = await api.get<IProductApiModel>(`/products/${id}`);

  return Product.fromApiModel(product);
};

export { getProduct };
